import Carousel from "../../Tools/Carousel";
import DpcCard from "./DpcCard";
import useDpcItems from "../utils/useDpcItems";
import useCart from "../utils/useCart";

export default function DpcCarousel(){

    const { product, setCart } = useCart()

    const { data: dpcItems, isSuccess } = useDpcItems()

    return isSuccess &&

        <Carousel 
            items={dpcItems}
            itemsPerPage={itemsPerPage()} 
            renderItem={item => 
                <DpcCard 
                    item={item}
                    disabled={item.id === product}
                    key={item.id}
                />
            }
            searchLabel="Rechercher une formation"
            filterItem={(item, search) => 
                (item.title + item.teachers).toLowerCase().includes(search.toLowerCase())
            }
            selected={product ? dpcItems.find(i => i.id === product) : null}
            onDeselect={() => setCart({ product: null })}
        />
}

function itemsPerPage(){

    let w = window.innerWidth;

    if(w > 1400) return 3;

    if(w > 1000) return 2;

    return 1;
}